module.exports = __webpack_public_path__ + "img/085885e.webp";